import React from 'react';
import Component from '@vfuk/core-loader';
const Loader = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Loader;
